export const sleep = (ts: number) => new Promise(r => setTimeout(r, ts));